<nz-form-item>
  <div>
    <span [class]="labelClass">{{ label }}</span>
    @if (secondLabel) {
    <span [class]="secondLabelClass" style="margin-left: 4px">{{ secondLabel }}</span>
    }
  </div>
  <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
    <textarea style="border: 1px solid #d9d9d9 !important" [rows]="rows" nz-input [formControl]="asFormControl(inputFormControl)"></textarea>
    <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
  </nz-form-control>
</nz-form-item>
